import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100wh;
  height: 100vh;
  background-color: #f0f0f0;
`;

export default { Container };
